import { render, staticRenderFns } from "./ChatInputComponent.vue?vue&type=template&id=43397592&scoped=true&"
import script from "./ChatInputComponent.vue?vue&type=script&lang=js&"
export * from "./ChatInputComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43397592",
  null
  
)

export default component.exports